import { Button, Modal } from "antd";
import styled from "styled-components/macro";
import { COLORS } from "../../../layout/theme";

export const Page = styled.div`
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 32px 16px;
	background: #f4f5f7;
	position: relative;
	overflow: hidden;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		background-image:
			radial-gradient(
				circle at 20% 20%,
				rgba(24, 95, 165, 0.06) 0%,
				transparent 50%
			),
			radial-gradient(
				circle at 80% 80%,
				rgba(27, 58, 107, 0.05) 0%,
				transparent 50%
			);
		pointer-events: none;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		background-image: radial-gradient(circle, #cbd5e1 1px, transparent 1px);
		background-size: 28px 28px;
		opacity: 0.35;
		pointer-events: none;
	}
`;

export const Main = styled.div`
	position: relative;
	z-index: 1;
	width: 100%;
	max-width: 760px;
	display: flex;
	flex-direction: column;
	align-items: center;
	animation: fadeUp 0.4s ease both;

	@keyframes fadeUp {
		from {
			opacity: 0;
			transform: translateY(16px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export const LogoWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 28px;
`;

export const Header = styled.div`
	width: 100%;
	background: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-radius: 16px 16px 0 0;
	border-bottom: none;
	padding: 30px 32px 0;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

	@media only screen and (max-width: 520px) {
		padding: 24px 20px 0;
	}
`;

export const HeaderTitle = styled.h1`
	font-size: 24px;
	font-weight: 600;
	color: #111827;
	letter-spacing: -0.03em;
	margin: 0 0 6px 0;
`;

export const HeaderDesc = styled.p`
	font-size: 13px;
	color: #6b7280;
	line-height: 1.5;
	margin: 0 0 24px 0;
`;

export const Body = styled.div`
	width: 100%;
	background-color: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-top: none;
	border-radius: 0 0 16px 16px;
	padding: 0 32px 32px;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

	@media only screen and (max-width: 520px) {
		padding: 0 20px 24px;
	}
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
`;

export const TermsCard = styled.div`
	border: 1px solid #eef2f7;
	background: #fbfcfd;
	border-radius: 14px;
	padding: 18px;
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const TermsIntro = styled.p`
	margin: 0;
	font-size: 13px;
	line-height: 1.6;
	color: #6b7280;
`;

export const LinkList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const Text = styled.button`
	width: 100%;
	text-align: left;
	padding: 14px 16px;
	border: 1px solid #e5e7eb;
	border-radius: 10px;
	background: #ffffff;
	color: #185fa5;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;

	&:hover {
		background: #f8fafc;
		border-color: #b0b7c3;
	}
`;

export const Space = styled.div`
	height: 6px;
`;

export const AntdModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 18px;
		overflow: hidden;
	}

	.ant-modal-header {
		border-bottom: 1px solid #eef2f7;
		padding: 18px 22px;
	}

	.ant-modal-title {
		font-weight: 700;
		color: #111827;
	}

	.ant-modal-body {
		background-color: #f8fafc;
		padding: 20px 24px;
		max-height: 70vh;
		overflow-y: auto;
	}

	.ant-modal-footer {
		display: none;
	}
`;

export const AntdButton = styled(Button)`
	width: 100%;
	height: 46px;
	border-radius: 8px;
	border: none;
	background: #1b3a6b;
	box-shadow: 0 2px 8px rgba(27, 58, 107, 0.2);
	font-size: 14px;
	font-weight: 500;

	&:hover,
	&:focus,
	&:active {
		background: #152e56 !important;
		color: white !important;
		border: none !important;
		box-shadow: 0 4px 12px rgba(27, 58, 107, 0.28);
	}

	@media only screen and (max-width: 520px) {
		white-space: normal;
		height: auto;
		min-height: 46px;
		padding: 10px 14px;
	}
`;

export const Footer = styled.div`
	margin-top: 8px;
	text-align: center;
	font-size: 12px;
	color: #9ca3af;
	line-height: 1.5;
`;

export const TrustRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	flex-wrap: wrap;
	margin-top: 22px;
`;

export const TrustItem = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	font-size: 11px;
	color: #9ca3af;
`;

export const TrustDot = styled.div`
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background: #b0b7c3;
`;
